/**
 * Форматує час у вигляді "HH:mm" (обрізає секунди, не змінюючи часову зону).
 * Підтримає: "HH:mm:ss", "YYYY-MM-DD HH:mm:ss", ISO-рядок, Date, timestamp.
 *
 * @param {string|Date|number} input - Джерело часу.
 * @returns {string} Вигляд "HH:mm" або '' для некоректного вводу.
 */
export default function toHm(input) {
	if (input == null || input === '') return '';

	// 1) Рядки: дістаємо год/хв з кінця ("... 09:16:00", "09:16", тощо)
	if (typeof input === 'string') {
		const m = input.match(
			/(?:^|[ T])(\d{1,2}):(\d{1,2})(?::\d{1,2}(?:\.\d{1,3})?)?(?: ?(?:Z|[+-]\d{2}:\d{2}))?$/
		);
		if (m) {
			const hh = String(m[1]).padStart(2, '0');
			const mm = String(m[2]).padStart(2, '0');
			return `${ hh }:${ mm }`;
		}
	}

	// 2) Date / timestamp
	const d = input instanceof Date ? input : new Date(input);
	if (Number.isNaN(d.getTime())) return '';

	const hh = String(d.getHours()).padStart(2, '0');
	const mm = String(d.getMinutes()).padStart(2, '0');
	return `${ hh }:${ mm }`;
}
